<template>
  <AuthWrapper>
    <a-form
      id="form-forgot-password"
      layout="vertical"
      class="login-form"
      :form="formForgotPassword"
      @submit="onSubmitForm"
      v-if="!isSentEmail"
      >
      <div class="forgot-password-title">
        <a-icon class="forgot-password-title__button" type="arrow-left" @click.prevent="backToSignInPage()" />
        <span class="forgot-password-title__text">Forgot Password</span>
      </div>
      <a-alert v-if="!isCorrectInfo" showIcon type="error">
        <template slot="message">
          Security Code was incorrect.
        </template>
        <template slot="description">
          Code is case-sensitive
        </template>
      </a-alert>

      <a-alert v-if="isCorrectInfo" type="info">
        <template slot="message">
          Enter the email address
        </template>
        <template slot="description">
          We’ll send you a code to reset your password.
        </template>
      </a-alert>
      <br />

      <a-form-item label="Email" has-feedback>
        <a-input
          v-decorator="[
            'email',
            {
              initialValue: email,
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: 'Please input your Email!',
                },
                {
                  message: 'Email invalid!',
                  type: 'email',
                },
              ],
            },
          ]"
          postfix
          placeholder="ID or Email"
          autocomplete="email"
        >
        </a-input>
      </a-form-item>

      <a-form-item label="Captcha">
        <a-row :gutter="8">
          <a-col :span="12">
            <a-input
              v-decorator="[
                'captchaText',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input the captcha you got!',
                    },
                  ],
                },
              ]"
              autocomplete="off"
            />
            <div class="new-code-link">
              <a @click="getChallenge()">New code</a>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="captcha">
              <img class="captcha__image" :src="captchaImage" alt="captcha" v-if="captchaImage" />
            </div>
          </a-col>
        </a-row>
      </a-form-item>

      <a-form-item class="mb-0">
        <a-button :disabled="isFormInvalid()" type="primary" html-type="submit" size="large" class="btn-form">
          Submit
        </a-button>
      </a-form-item>
    </a-form>
    <div class="notification" v-if="isSentEmail">
      <div class="color-pr">An email has been sent to</div>
      <a :href="`mailto:${email}`">
        {{ email }}
      </a>
      <div class="color-pr">
        Follow the directions in the email to reset your password
        <br />
        If you did not receive an email, please check your junk mail box.
      </div>
      <a-button :disabled="count > 0" type="primary" size="large" html-type="button" class="resend-button" @click="resendEmail()">
        Resend Email
        <template v-if="count > 0">
          ({{ count }})
        </template>
      </a-button>
      <a href="javascript:void(0)" class="redirect-sign-in" @click.prevent="backToSignInPage()">Back to sign in</a>
    </div>
  </AuthWrapper>
</template>

<script>
  import AuthWrapper from './AuthWrapper';
  import AuthenticationService from '../services/authentication.service';

  export default {
    name: 'ForgotPassword',
    components: {
      AuthWrapper,
    },
    data() {
      return {
        email: '',
        isCorrectInfo: true,
        isCheckingFromServer: false,
        isSentEmail: false,
        captchaId: '',
        captchaImage: '',
        count: 0,
        requestBody: {},
      };
    },
    beforeCreate() {
      this.formForgotPassword = this.$form.createForm(this, {
        name: 'normal_forgot',
      });
    },
    beforeMount() {
      this.email = this.$route.query.email ? decodeURIComponent(this.$route.query.email) : '';
    },
    created() {
      this.getChallenge();
    },
    methods: {
      async getChallenge() {
        const { challenge_id, image } = await AuthenticationService.getChallenge();
        this.captchaId = challenge_id;
        this.captchaImage = image;
      },

      backToSignInPage() {
        this.$router.push('/login');
      },
      onSubmitForm(e) {
        e.preventDefault();
        this.formForgotPassword.validateFields((err, formValue) => {
          if (!err) {
            const { email, captchaText } = formValue;
            this.email = email;
            this.requestBody = {
              email,
              challenge_id: this.captchaId,
              challenge_response: captchaText,
            };
            this.handleForgotPassword(this.requestBody);
          }
        });
      },
      async handleForgotPassword(requestBody) {
        this.isCheckingFromServer = true;
        try {
          await AuthenticationService.forgotPassword(requestBody);
          this.isSentEmail = true;
          this.$showSuccessMessage('Sent email');
          this.setCountDown(30);
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
          this.isCorrectInfo = false;
        } finally {
          this.isCheckingFromServer = false;
        }
      },
      async resendEmail() {
        this.handleForgotPassword(this.requestBody);
      },
      async setCountDown(initCount) {
        this.count = initCount;
        if (this.count > 0) {
          await this.sleep(1000);
          this.setCountDown(this.count - 1);
        }
      },
      async sleep(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
      },
      isFormInvalid() {
        if (!this.formForgotPassword) {
          return true;
        }
        if (this.isCheckingFromServer) {
          return true;
        }
        return !this.formForgotPassword.getFieldValue('email')
        || !this.formForgotPassword.getFieldValue('captchaText')
        || !!this.formForgotPassword.getFieldError('email')
        || !!this.formForgotPassword.getFieldError('captchaText');
      }
    },
  };
</script>

<style lang="scss" scoped>
  .btn-form {
    display: block;
    width: 100%;
    margin-top: 27px;
  }

  .captcha {
    width: 155px;
    height: 60px;

    &__image {
      width: 100%;
    }
  }

  .new-code-link {
    margin-top: 5px;
    font-size: 11px;
    a {
      text-decoration: underline;
    }
  }

  .forgot-password-title {
    margin-bottom: 20px;
    margin-top: 20px;

    &__button {
      padding-right: 10px;
      color: $prLgt;
      font-size: 16px;
      cursor: pointer;

      &:hover {
        color: $prDrk;
      }
    }

    &__text {
      color: $pr;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .notification {
    text-align: center;
    font-size: 13px;
    margin-top: 20px;
  }

  .resend-button {
    margin-top: 45px;
    width: 320px;
  }
  .redirect-sign-in {
    display: inline-block;
    text-align: right;
    width: 320px;
    margin: 5px auto;
  }
</style>
